const styles = theme => ({
    paper: {
        padding: '10px',
        paddingBottom: 50
    }
});

export default styles;
